import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=7b277b2c&scoped=true"
import script from "./FaqCard.vue?vue&type=script&lang=js"
export * from "./FaqCard.vue?vue&type=script&lang=js"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=7b277b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b277b2c",
  null
  
)

export default component.exports